module.exports = __webpack_public_path__ + "img/banner3.bfbd5fae.jpg";